import route from './route'

export default {
  route
} as { [key: string]: any }
